import * as React from 'react';
import { EventName } from '@lit-labs/react';
import { PdsUtilityNavItem as PdsUtilityNavItemElement } from '@principal/design-system';
import { PdsUtilityNavItemProps } from '../../built-component-props';
import { createPdsReactComponent } from '../../create-pds-react-component';

export const PdsUtilityNavItem =
  createPdsReactComponent<PdsUtilityNavItemProps>()({
    tagName: 'pds-utility-nav-item',
    elementClass: PdsUtilityNavItemElement,
    react: React,
    events: {
      onHandleClick: 'pds-utility-nav-item-click' as EventName<CustomEvent>,
    },
  });
